(function () {
  'use strict';

  var measurementId = 'G-ZCCF1RPCT5';
  var pendingEvents = [];
  var analyticsReady = false;
  var ownerMode = false;

  function configureOwnerMode() {
    var url = new URL(window.location.href);
    var requestedMode = url.searchParams.get('koh_owner_mode');

    try {
      if (requestedMode === 'on') {
        localStorage.setItem('koh_owner_mode', 'on');
      } else if (requestedMode === 'off') {
        localStorage.removeItem('koh_owner_mode');
      }
      ownerMode = localStorage.getItem('koh_owner_mode') === 'on';
    } catch (error) {
      ownerMode = requestedMode === 'on';
    }

    if (requestedMode === 'on' || requestedMode === 'off') {
      url.searchParams.delete('koh_owner_mode');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }
  }

  function publishToShopify(eventName, details) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('kirur_oz_hadar:' + eventName, details);
    }
  }

  function sendEvent(eventName, details) {
    if (ownerMode) return;

    var eventDetails = Object.assign({
      page_location: window.location.href,
      page_title: document.title,
      transport_type: 'beacon'
    }, details || {});

    publishToShopify(eventName, eventDetails);

    if (!analyticsReady || typeof window.gtag !== 'function') {
      pendingEvents.push([eventName, eventDetails]);
      return;
    }

    window.gtag('event', eventName, eventDetails);
  }

  function initializeGoogleAnalytics() {
    if (analyticsReady) return;
    analyticsReady = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(script);

    pendingEvents.splice(0).forEach(function (queuedEvent) {
      window.gtag('event', queuedEvent[0], queuedEvent[1]);
    });
  }

  function analyticsAllowed() {
    return !window.Shopify || !Shopify.customerPrivacy || Shopify.customerPrivacy.analyticsProcessingAllowed();
  }

  function initializeWithPrivacy() {
    if (ownerMode) return;

    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') {
      initializeGoogleAnalytics();
      return;
    }

    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      if (analyticsAllowed()) initializeGoogleAnalytics();
    });

    document.addEventListener('visitorConsentCollected', function () {
      if (analyticsAllowed()) initializeGoogleAnalytics();
    });
  }

  function trackSuccessfulForms() {
    document.querySelectorAll('[data-koh-conversion-success]').forEach(function (marker) {
      var eventName = marker.getAttribute('data-koh-conversion-success');
      var storageKey = 'koh_conversion_' + eventName + '_' + window.location.pathname + window.location.search;
      try {
        if (sessionStorage.getItem(storageKey) === 'sent') return;
        sessionStorage.setItem(storageKey, 'sent');
      } catch (error) {}

      sendEvent(eventName, {
        lead_type: marker.getAttribute('data-koh-lead-type') || 'contact_form',
        form_id: marker.closest('form') ? marker.closest('form').id : ''
      });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var eventName = '';
    var leadType = '';

    if (/^tel:/i.test(href)) {
      eventName = 'koh_phone_click';
      leadType = 'phone';
    } else if (/wa\.me|api\.whatsapp\.com|whatsapp:\/\//i.test(href)) {
      eventName = 'koh_whatsapp_click';
      leadType = 'whatsapp';
    }

    if (!eventName) return;
    sendEvent(eventName, {
      lead_type: leadType,
      link_url: link.href,
      link_text: (link.textContent || '').trim().slice(0, 100)
    });
  });

  configureOwnerMode();
  initializeWithPrivacy();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSuccessfulForms);
  } else {
    trackSuccessfulForms();
  }

  window.KOHConversions = {
    track: sendEvent,
    isOwnerMode: function () { return ownerMode; }
  };
})();
